import {
  ClaimRewardApiResponse,
  DailyLoginCalendarResponse,
  HistoryApiResponse,
} from 'routes/dailyRewards/dailyRewards.models';

const prize = (id: number, name: string, kind: string, icon_url?: string) => ({ id, name, kind, distribution_type: 'per_person', icon_url });
const reward = (id: number, date: string, p: ReturnType<typeof prize>, vip_multiplier = '1.0') => ({
  id,
  date,
  prize: p,
  claim_limit: 15,
  claims_remaining: 15,
  limit_reached: false,
  image_override: p.icon_url ?? null,
  vip_multiplier,
  vip_image_override: null,
});

export const DAILY_REWARDS_CALENDAR_MOCK: DailyLoginCalendarResponse = {
  year: 2026,
  month: 2,
  today: '2026-02-25',
  claim_available: true,
  next_claim_date: null,
  today_claims_remaining: 1,
  min_rmv_required: '1000',
  min_token_worth_required: '5000',
  user_eligibility: {
    eligible: true,
    checks: [
      { gate: 'rmv_balance', required: '1000', actual: '2500', met: true },
      { gate: 'token_worth', required: '5000', actual: '8200', met: true },
    ],
  },
  days: [
    // Row 1: Mon 26 Jan – Sun 1 Feb (prev month padding + 1 Feb)
    {
      date: '2026-01-26',
      day: 26,
      label: '26 Jan',
      status: 'PAST_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-01-27',
      day: 27,
      label: '27 Jan',
      status: 'PAST_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-01-28',
      day: 28,
      label: '28 Jan',
      status: 'PAST_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-01-29',
      day: 29,
      label: '29 Jan',
      status: 'PAST_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-01-30',
      day: 30,
      label: '30 Jan',
      status: 'PAST_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-01-31',
      day: 31,
      label: '31 Jan',
      status: 'PAST_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-01',
      day: 1,
      label: '1 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(1, '2026-02-01', prize(1, '500 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },

    // Row 2: 2–8 Feb
    {
      date: '2026-02-02',
      day: 2,
      label: '2 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(2, '2026-02-02', prize(2, '5 WOF Spins', 'wof_spins')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-03',
      day: 3,
      label: '3 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(3, '2026-02-03', prize(3, '750 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-04',
      day: 4,
      label: '4 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(4, '2026-02-04', prize(4, '10 WOF Spins', 'wof_spins')),
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-05',
      day: 5,
      label: '5 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(5, '2026-02-05', prize(5, '1000 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-06',
      day: 6,
      label: '6 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(6, '2026-02-06', prize(6, '500 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-07',
      day: 7,
      label: '7 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(7, '2026-02-07', prize(7, '5 WOF Spins', 'wof_spins')),
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-08',
      day: 8,
      label: '8 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(8, '2026-02-08', prize(8, '750 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },

    // Row 3: 9–15 Feb
    {
      date: '2026-02-09',
      day: 9,
      label: '9 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(9, '2026-02-09', prize(9, '500 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-10',
      day: 10,
      label: '10 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(10, '2026-02-10', prize(10, '10 WOF Spins', 'wof_spins')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-11',
      day: 11,
      label: '11 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(11, '2026-02-11', prize(11, '1000 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-12',
      day: 12,
      label: '12 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(12, '2026-02-12', prize(12, '5 WOF Spins', 'wof_spins')),
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-13',
      day: 13,
      label: '13 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(13, '2026-02-13', prize(13, '750 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-14',
      day: 14,
      label: '14 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(14, '2026-02-14', prize(14, '500 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-15',
      day: 15,
      label: '15 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(15, '2026-02-15', prize(15, '10 WOF Spins', 'wof_spins')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },

    // Row 4: 16–22 Feb
    {
      date: '2026-02-16',
      day: 16,
      label: '16 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(16, '2026-02-16', prize(16, '1000 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-17',
      day: 17,
      label: '17 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(17, '2026-02-17', prize(17, '500 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-18',
      day: 18,
      label: '18 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(18, '2026-02-18', prize(18, '5 WOF Spins', 'wof_spins')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-19',
      day: 19,
      label: '19 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(19, '2026-02-19', prize(19, '750 RMV', 'rmv')),
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-20',
      day: 20,
      label: '20 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(20, '2026-02-20', prize(20, '1000 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-21',
      day: 21,
      label: '21 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(21, '2026-02-21', prize(21, '500 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-22',
      day: 22,
      label: '22 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(22, '2026-02-22', prize(22, '10 WOF Spins', 'wof_spins')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },

    // Row 5: 23–28 Feb + 1 Mar
    {
      date: '2026-02-23',
      day: 23,
      label: '23 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(23, '2026-02-23', prize(23, '750 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-24',
      day: 24,
      label: '24 Feb',
      status: 'PAST_DATE',
      current_month: true,
      reward: reward(24, '2026-02-24', prize(24, '500 RMV', 'rmv')),
      claimed: true,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-25',
      day: 25,
      label: '25 Feb',
      status: 'TODAY',
      current_month: true,
      reward: reward(25, '2026-02-25', prize(25, '5000 RMV', 'rmv')),
      claimed: false,
      claimable: true,
      limit_reached: false,
    },
    {
      date: '2026-02-26',
      day: 26,
      label: '26 Feb',
      status: 'FUTURE_DATE',
      current_month: true,
      reward: reward(26, '2026-02-26', prize(26, '5 WOF Spins', 'wof_spins')),
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-27',
      day: 27,
      label: '27 Feb',
      status: 'FUTURE_DATE',
      current_month: true,
      reward: reward(27, '2026-02-27', prize(27, '1000 RMV', 'rmv')),
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-02-28',
      day: 28,
      label: '28 Feb',
      status: 'FUTURE_DATE',
      current_month: true,
      reward: reward(28, '2026-02-28', prize(28, '10 WOF Spins', 'wof_spins')),
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-03-01',
      day: 1,
      label: '1 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },

    // Row 6: 2–8 Mar (next month padding)
    {
      date: '2026-03-02',
      day: 2,
      label: '2 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-03-03',
      day: 3,
      label: '3 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-03-04',
      day: 4,
      label: '4 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-03-05',
      day: 5,
      label: '5 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-03-06',
      day: 6,
      label: '6 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-03-07',
      day: 7,
      label: '7 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
    {
      date: '2026-03-08',
      day: 8,
      label: '8 Mar',
      status: 'FUTURE_DATE',
      current_month: false,
      reward: null,
      claimed: false,
      claimable: false,
      limit_reached: false,
    },
  ],
};

export const DAILY_REWARDS_CLAIM_MOCK: ClaimRewardApiResponse = {
  status: 'CLAIMED',
  message: 'Reward claimed successfully',
  reward: reward(25, '2026-02-25', prize(25, '5000 RMV', 'rmv')),
};

export const DAILY_REWARDS_HISTORY_MOCK: HistoryApiResponse = {
  count: 12,
  next: 'http://localhost/api/v1/daily-login/history/?page=2',
  previous: null,
  results: [
    {
      id: 1,
      date: '2026-02-24',
      day: 24,
      prize: prize(24, '500 RMV', 'rmv'),
      distributed: true,
      claimed_at: '2026-02-24T10:15:00Z',
    },
    {
      id: 2,
      date: '2026-02-23',
      day: 23,
      prize: prize(23, '750 RMV', 'rmv'),
      distributed: true,
      claimed_at: '2026-02-23T09:30:00Z',
    },
    {
      id: 3,
      date: '2026-02-22',
      day: 22,
      prize: prize(22, '10 WOF Spins', 'wof_spins'),
      distributed: true,
      claimed_at: '2026-02-22T11:00:00Z',
    },
    {
      id: 4,
      date: '2026-02-21',
      day: 21,
      prize: prize(21, '500 RMV', 'rmv'),
      distributed: true,
      claimed_at: '2026-02-21T08:45:00Z',
    },
    {
      id: 5,
      date: '2026-02-20',
      day: 20,
      prize: prize(20, '1000 RMV', 'rmv'),
      distributed: true,
      claimed_at: '2026-02-20T14:20:00Z',
    },
    {
      id: 6,
      date: '2026-02-18',
      day: 18,
      prize: prize(18, '5 WOF Spins', 'wof_spins'),
      distributed: true,
      claimed_at: '2026-02-18T10:00:00Z',
    },
    {
      id: 7,
      date: '2026-02-17',
      day: 17,
      prize: prize(17, '500 RMV', 'rmv'),
      distributed: true,
      claimed_at: '2026-02-17T12:30:00Z',
    },
    {
      id: 8,
      date: '2026-02-16',
      day: 16,
      prize: prize(16, '1000 RMV', 'rmv'),
      distributed: true,
      claimed_at: '2026-02-16T09:15:00Z',
    },
    {
      id: 9,
      date: '2026-02-15',
      day: 15,
      prize: prize(15, '10 WOF Spins', 'wof_spins'),
      distributed: true,
      claimed_at: '2026-02-15T11:45:00Z',
    },
    {
      id: 10,
      date: '2026-02-14',
      day: 14,
      prize: prize(14, '500 RMV', 'rmv'),
      distributed: true,
      claimed_at: '2026-02-14T10:30:00Z',
    },
  ],
};
